module.exports = __webpack_public_path__ + "img/auto.c778de6f.png";